import { Component, ElementRef, Injector, Input, ViewChild } from '@angular/core';
import { EOrderType, IPaginationOptions, ISortOptions } from '../../core/ISortOptions';
import { JobsService } from '../jobs.service';
import { BzgModalService } from 'bz-genome-angular';
import { EJobType } from '../job-type.enum';
import { EJobState } from '../job-state.enum';
import { ResultErrorsComponent } from '../result-errors/result-errors.component';
import { OverlayRef } from '@angular/cdk/overlay';
import { PortalInjector } from '@angular/cdk/portal';
import { JobsDetailComponent } from '../jobs-detail/jobs-detail.component';
import { OverlayService } from 'app/shared/services/overlay.service';
import { IJOB_DATA } from '../job-injector-data';
import { JobsFilterComponent } from '../jobs-filter/jobs-filter.component';
import { IFilterColumn } from '../IFilterColumn';
import { IJob, IJobResult } from '../IJob';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'jobs-table',
  templateUrl: 'jobs-table.component.html',
  styleUrls: ['jobs-table.component.scss']
})
export class JobsTableComponent {
  @Input() jobState: EJobState = EJobState.Executed;
  @Input() jobType: EJobType;
  @Input() title: string;
  @Input() subtitle: string;
  public titleTranslate: string;
  public subtitleTranslate: string;
  public jobsResult: IJobResult;
  public isLoadingJobs = false;
  public columns: Array<IFilterColumn> = [
    { key: 'taskDisplayName', value: 'JOBS.COLUMN_ACTIVITY', visible: true, type: 'text' },
    { key: 'name', value: 'JOBS.COLUMN_NAME', visible: true, type: 'link', action: (job) => { } },
    { key: 'radNumber', value: 'JOBS.COLUMN_CASE_NUMBER', visible: true, type: 'text' },
    { key: 'description', value: 'JOBS.COLUMN_DESCRIPTION', visible: true, type: 'text' },
    { key: 'idCase', value: 'JOBS.COLUMN_CASE_ID', visible: true, type: 'text' },
    { key: 'enabled', value: 'JOBS.COLUMN_ENABLE', visible: true, type: 'boolean', readonly: true },
    { key: 'creationDate', value: 'JOBS.COLUMN_CREATION_DATE', visible: true, type: 'date' },
    { key: 'nextRuntime', value: 'JOBS.COLUMN_NEXT_RUN_TIME', visible: true, type: 'date' },
    { key: 'result', value: 'JOBS.COLUMN_LAST_RESULT', blocked: true, visible: true, type: 'result' }
  ];
  public sortOptions: ISortOptions = { columnName: '', orderType: EOrderType.none };
  public paginationOptions: IPaginationOptions;
  public overlayRef: OverlayRef;
  @ViewChild('jobDetailComponent', { static: false }) jobDetailComponent: JobsDetailComponent;


  public currentJob: any;

  constructor(private _jobsService: JobsService,
    private _modalService: BzgModalService, private _elemntRef: ElementRef,
    private _overlayService: OverlayService, private injector: Injector,
    private _i18nService: I18nService) { }

  async ngOnInit() {
    if (this.jobType === EJobType.Wait) {
      _.remove(this.columns, (column) => {
        return column.key === 'taskDisplayName';
      });
      if (this.jobState === EJobState.Executed) {
        _.remove(this.columns, (column) => {
          return column.key === 'nextRuntime';
        });
      }
    }

    this.sortByColumn('name', 0);
  }

  ngOnChanges() {
    if (this.title && this.subtitle) {
      this.titleTranslate = this._i18nService.instant(this.title);
      this.subtitleTranslate = this._i18nService.instant(this.subtitle);
    }
  }

  public async sortByColumn(columnName: string, orderType: number) {
    this.sortOptions.columnName = columnName;
    this.sortOptions.orderType = orderType;
    this.isLoadingJobs = true;
    this.jobsResult = await this._jobsService.getJobsByType(this.jobType, this.jobState, this.sortOptions, this.paginationOptions);
    this.isLoadingJobs = false;
  }

  public async onPaginationEvent(event) {
    this.paginationOptions = { currentPage: event.pageIndex + 1, pageSize: event.pageSize };
    this.isLoadingJobs = true;
    this.jobsResult = await this._jobsService.getJobsByType(this.jobType, this.jobState, this.sortOptions, this.paginationOptions);
    this.isLoadingJobs = false;
  }

  public openErrorModal(errorMessage: string) {
    this._modalService.open(ResultErrorsComponent, {
      closeOnBackdropClick: true,
      closeOnRouterNavigation: true,
      data: {
        title: 'JOBS.RESULT_ERROR_MESSAGE',
        message: errorMessage
      }
    });
  }

  public async showJobDetail(job: IJob) {
    this.isLoadingJobs = true;
    this.currentJob = await this._jobsService.getJobById(job.id);
    this.currentJob.radNumber = job.radNumber;
    this.isLoadingJobs = false;
    const injector = this.createInjector(this.currentJob);
    this._overlayService.show($('.bz-sidebar-content')[0], JobsDetailComponent, injector, async () => {
      this.isLoadingJobs = true;
      this.jobsResult = await this._jobsService.getJobsByType(this.jobType, this.jobState, this.sortOptions, this.paginationOptions);
      this.isLoadingJobs = false;
    });
  }

  private createInjector(job: IJob): PortalInjector {
    const injectionTokens = new WeakMap();
    const title = this.getJobDetailTitle();
    const jobType = this.jobType;
    const params = { job, title, jobType }
    injectionTokens.set(IJOB_DATA, params);
    return new PortalInjector(this.injector, injectionTokens);
  }

  private getJobDetailTitle(): string {
    switch (this.jobType) {
      case EJobType.Alarm:
        return 'ALERTS.JOB_DETAIL';

      case EJobType.Wait:
        return 'WAITS.JOB_DETAIL';

      default:
        break;
    }
  }

  showJobsFilter() {
    this.openModalFilter(this.columns);
  }

  openModalFilter(columns: any) {
    const filterModal = this._modalService.open(JobsFilterComponent, {
      closeOnBackdropClick: false,
      data: {
        columns
      }, width: '40%',
      maxWidth: 'none',
      maxHeight: '600px',
      closeOnRouterNavigation: true
    });
    filterModal.afterClosed().subscribe((result: any) => {
      if (result)
        this.columns = result.columns;
    });
  }
}
